const DB_NAME = 'tttc-feedback';
const DB_VERSION = 1;
const STORE_NAME = 'pending-feedback';

let db = null;

function openDatabase() {
    return new Promise((resolve, reject) => {
        if (db) {
            resolve(db);
            return;
        }

        const request = indexedDB.open(DB_NAME, DB_VERSION);

        request.onerror = () => {
            reject(request.error);
        };

        request.onsuccess = () => {
            db = request.result;
            resolve(db);
        };

        request.onupgradeneeded = (event) => {
            const database = event.target.result;
            if (!database.objectStoreNames.contains(STORE_NAME)) {
                database.createObjectStore(STORE_NAME, { keyPath: 'submissionId' });
            }
        };
    });
}

export async function saveFeedback(submissionId, studentId, blob, type) {
    const database = await openDatabase();
    return new Promise((resolve, reject) => {
        const transaction = database.transaction([STORE_NAME], 'readwrite');
        const store = transaction.objectStore(STORE_NAME);

        const data = {
            submissionId,
            studentId,
            blob,
            type,
            createdAt: Date.now()
        };

        const request = store.put(data);

        request.onsuccess = () => resolve();
        request.onerror = () => reject(request.error);
    });
}

export async function getFeedback(submissionId) {
    const database = await openDatabase();
    return new Promise((resolve, reject) => {
        const transaction = database.transaction([STORE_NAME], 'readonly');
        const store = transaction.objectStore(STORE_NAME);
        const request = store.get(submissionId);

        request.onsuccess = () => resolve(request.result || null);
        request.onerror = () => reject(request.error);
    });
}

export async function getAllFeedback() {
    const database = await openDatabase();
    return new Promise((resolve, reject) => {
        const transaction = database.transaction([STORE_NAME], 'readonly');
        const store = transaction.objectStore(STORE_NAME);
        const request = store.getAll();

        request.onsuccess = () => resolve(request.result || []);
        request.onerror = () => reject(request.error);
    });
}

export async function deleteFeedback(submissionId) {
    const database = await openDatabase();
    return new Promise((resolve, reject) => {
        const transaction = database.transaction([STORE_NAME], 'readwrite');
        const store = transaction.objectStore(STORE_NAME);
        const request = store.delete(submissionId);

        request.onsuccess = () => resolve();
        request.onerror = () => reject(request.error);
    });
}

export default {
    saveFeedback,
    getFeedback,
    getAllFeedback,
    deleteFeedback
};



// WEBPACK FOOTER //
// ./src/util/feedback-storage.js